<template>
    <v-container fluid class="pa-0">
        <v-row column justify-center align-center>
            <v-col cols="12" class="py-0">
                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <!-- <ValidationObserver ref="observer" v-slot="{ invalid }"> -->
                    <v-form
                        id="catalogForm"
                        ref="catalogForm"
                        data-netlify="true"
                        data-netlify-honeypot="bot-field"
                        name="catalogForm"
                        action="/catalog/"
                        method="POST"
                        @submit.prevent="handleSubmit(handleSubmission)"
                    >
                        <!-- @submit.prevent="handleSubmit(handleSubmission)" -->
                        <input
                            id="form-name"
                            type="hidden"
                            name="form-name"
                            value="catalogForm"
                        />
                        <v-container class="catalogForm--wrapper">
                            <v-row column justify-center align-center>
                                <v-col cols="12">
                                    <h2>
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string:
                                                    'downloadTheC3ControlsCatalog',
                                            }"
                                        />
                                    </h2>
                                    <!-- <v-switch
                                        v-model="requestDownload"
                                        class="mx-2"
                                        color="success"
                                        label="Download Catalog"
                                    ></v-switch> -->
                                </v-col>
                                <!-- <v-col cols="6">
                                    <v-switch
                                        v-model="requestPaper"
                                        class="mx-2"
                                        color="success"
                                        label="Request Mailed Catalog"
                                    ></v-switch>
                                </v-col> -->
                                <v-col cols="12" md="6">
                                    <!-- FIRST NAME -->
                                    <ValidationProvider
                                        name="firstname"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="firstname"
                                                v-model="firstname"
                                                name="firstname"
                                                :label="localize('firstName')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider
                                        name="lastname"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="lastname"
                                                v-model="lastname"
                                                name="lastname"
                                                :label="localize('lastName')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider
                                        name="email"
                                        rules="required|email|emoji"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="email"
                                                v-model="email"
                                                name="email"
                                                :label="localize('email')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider
                                        name="phone"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="phone"
                                                v-model="phone"
                                                v-mask="phoneMask"
                                                name="phone"
                                                :label="localize('phone')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider
                                        name="jobtitle"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="jobtitle"
                                                v-model="jobtitle"
                                                name="jobtitle"
                                                :label="localize('jobTitle')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider
                                        name="hs_persona"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-select
                                                id="hs_persona"
                                                v-model="hs_persona"
                                                :items="jobRoleOptions"
                                                name="hs_persona"
                                                item-text="label"
                                                item-value="value"
                                                outlined
                                                dense
                                                :hide-details="true"
                                                :label="
                                                    localize('whatIsYourRole')
                                                "
                                            ></v-select>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider
                                        name="company"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="company"
                                                v-model="company"
                                                name="company"
                                                :label="localize('company')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col v-show="requestPaper" cols="12" md="12">
                                    <ValidationProvider
                                        name="country"
                                        :rules="{ required: requestPaper }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-select
                                                id="country"
                                                v-model="country"
                                                :items="countries"
                                                name="country"
                                                item-text="name"
                                                item-value="name"
                                                :label="localize('country')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                                @change="clearFields()"
                                            >
                                                <!-- <option disabled value=""
                                                                >Please select one</option
                                                    >-->
                                                <template
                                                    slot="selection"
                                                    slot-scope="data"
                                                >
                                                    <!-- HTML CAN WRAP THIS -->
                                                    {{ data.item.name }}
                                                </template>
                                                <template
                                                    slot="item"
                                                    slot-scope="data"
                                                >
                                                    <!-- HTML CAN WRAP THIS -->
                                                    {{ data.item.name }}
                                                </template>
                                            </v-select>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col v-show="requestPaper" cols="12" md="12">
                                    <ValidationProvider
                                        name="address"
                                        :rules="{ required: requestPaper }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="address"
                                                v-model="address"
                                                name="address"
                                                :label="localize('address')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col v-show="requestPaper" cols="12" md="12">
                                    <ValidationProvider
                                        name="street_address_2"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="street_address_2"
                                                v-model="street_address_2"
                                                name="street_address_2"
                                                :label="
                                                    localize(
                                                        'addressLine2Optional'
                                                    )
                                                "
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col v-show="requestPaper" cols="12" md="12">
                                    <ValidationProvider
                                        name="city"
                                        :rules="{ required: requestPaper }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="city"
                                                v-model="city"
                                                name="city"
                                                :label="localize('cityTown')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col v-show="requestPaper" cols="12" md="6">
                                    <ValidationProvider
                                        name="state"
                                        :rules="{ required: requestPaper }"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>

                                            <v-select
                                                v-show="
                                                    country ===
                                                        'United States' ||
                                                    country === 'Canada'
                                                "
                                                id="state"
                                                v-model="state"
                                                :items="
                                                    country === 'United States'
                                                        ? statesUS
                                                        : provincesCanada
                                                "
                                                name="state"
                                                item-text="name"
                                                item-value="name"
                                                :label="
                                                    localize('stateProvince')
                                                "
                                                outlined
                                                dense
                                                :hide-details="true"
                                            >
                                                <!-- <option disabled value=""
                                                                >Please select one</option
                                                    >-->
                                                <template
                                                    slot="selection"
                                                    slot-scope="data"
                                                >
                                                    <!-- HTML CAN WRAP THIS -->
                                                    {{ data.item.name }}
                                                </template>
                                                <template
                                                    slot="item"
                                                    slot-scope="data"
                                                >
                                                    <!-- HTML CAN WRAP THIS -->
                                                    {{ data.item.name }}
                                                </template>
                                            </v-select>
                                            <v-text-field
                                                v-show="
                                                    country !==
                                                        'United States' &&
                                                    country !== 'Canada'
                                                "
                                                id="state"
                                                v-model="state"
                                                name="state"
                                                :label="
                                                    localize('stateProvince')
                                                "
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col v-show="requestPaper" cols="12" md="6">
                                    <ValidationProvider
                                        name="zip"
                                        :rules="zipcodeValidationRule"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="zip"
                                                v-model="zip"
                                                name="zip"
                                                :label="
                                                    localize('zipPostalCode')
                                                "
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12">
                                    <recaptcha
                                        @success="onSuccess"
                                        @error="onError"
                                        @expired="onExpired"
                                    />
                                    <div
                                        v-if="captchaError"
                                        class="captcha-error"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'captchaRequired',
                                            }"
                                        />
                                    </div>
                                </v-col>

                                <v-col v-show="!okToDownload" cols="12">
                                    <v-btn
                                        type="submit"
                                        color="primary"
                                        :loading="loader"
                                        right
                                        @click="scrollIntoView()"
                                        ><TranslatableStringComponent
                                            :tstring="{
                                                string: `${requestButtonText}`,
                                            }"
                                    /></v-btn>
                                </v-col>
                                <v-col v-show="okToDownload" cols="12">
                                    <v-btn
                                        :href="downloadURL"
                                        target="_blank"
                                        color="warning"
                                        right
                                        >RE-{{
                                            localize('requestDownload')
                                        }}</v-btn
                                    >
                                </v-col>
                                <v-col cols="12">
                                    <div
                                        v-if="requestTypeNotSelected"
                                        class="red--text"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string:
                                                    'pleaseSelectTheTypeOfCatalogRequest',
                                            }"
                                        />
                                    </div>
                                    <div v-if="sending">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'submittingContactForm',
                                            }"
                                        />
                                    </div>
                                    <div v-if="waiting">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'awaitingContactForm',
                                            }"
                                        />
                                    </div>
                                    <div v-if="success">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'successfulContactForm',
                                            }"
                                        />
                                    </div>
                                    <div v-if="failure">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'failedContactForm',
                                            }"
                                        />
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </ValidationObserver>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { createHelpers } from 'vuex-map-fields'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import Cookies from 'js-cookie'
import { gtmEvent } from '~/plugins/global'
import encodeFormData from '~/mixins/encodeFormData'
import handleRecaptcha from '~/mixins/handleRecaptcha'
import downloadFile from '~/util/downloadFile'
import countries from '~/util/arrays/countries.js'
import statesUS from '~/util/statesUS.js'
import provincesCanada from '~/util/arrays/provincesCanada.js'
import handleSnackbar from '~/mixins/handleSnackbar'
import scrollIntoView from '~/mixins/scrollIntoView'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
const { mapFields } = createHelpers({
    getterType: 'getCatalogField',
    mutationType: 'updateCatalogField',
})

export default {
    name: 'FormCatalogRequest',
    components: {
        ValidationProvider,
        ValidationObserver,
        TranslatableStringComponent,
    },
    directives: {
        mask,
    },
    mixins: [encodeFormData, handleRecaptcha, handleSnackbar, scrollIntoView],
    data() {
        return {
            downloadURL:
                'https://cdn.sanity.io/files/tkk9p83q/production/e4c8b353c684c6929e8f37b105b19aa00acf28ee.pdf',
            hints: {
                email: '',
                password: '',
            },
            sending: false,
            waiting: false,
            success: false,
            failure: false,
            requestDownload: true,
            requestPaper: false,
            loader: false,
            okToDownload: false,
            requestTypeNotSelected: false,
            phoneMask: '(###) ###-####',
            countries,
            statesUS,
            provincesCanada,
        }
    },
    computed: {
        ...mapState('formSelectOptions', ['jobRoleOptions']),
        ...mapFields('catalog', [
            'firstname',
            'lastname',
            'email',
            'phone',
            'jobtitle',
            'hs_persona',
            'company',
            'country',
            'address',
            'street_address_2',
            'city',
            'state',
            'zip',
        ]),
        requestButtonText() {
            if (this.requestDownload && this.requestPaper) {
                return 'requestDownloadAndPaper'
            } else if (this.requestPaper) {
                return 'requestPaper'
            } else {
                return 'requestDownload'
            }
        },
        zipcodeValidationRule() {
            if (this.requestPaper) {
                return this.country === 'United States'
                    ? 'required|digits:5'
                    : 'required'
            } else {
                return { required: false }
            }
        },
    },
    methods: {
        handleSubmission() {
            if (!this.token) {
                this.captchaError = true
                return
            }
            if (!this.requestDownload && !this.requestPaper) {
                this.requestTypeNotSelected = true
                return
            } else {
                this.requestTypeNotSelected = false
            }
            this.sending = true
            this.waiting = false
            this.success = false
            this.failure = false
            this.loader = true
            const hubspotutk = Cookies.get('hubspotutk') || 0
            const axiosConfig = {
                header: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
            this.$axios
                .post('reCaptcha-server-side-validation', {
                    token: this.token,
                })
                .then((res) => {
                    // console.log('RECAPTCHA RESPONSE:', res)
                    if (res.data && res.data.success === false) throw res.data

                    this.$axios
                        .post(
                            process.env.V2_BASE_URL + '/catalog/',
                            this.encode({
                                'form-name': 'catalogForm',
                                // 'name.first': this.firstname,
                                // 'name.last': this.lastname,
                                // 'email': this.email,
                                // 'PhoneNumber.number': this.phone,
                                // 'customData.jobTitle': this.jobtitle,
                                // 'customData.persona': this.hs_persona,
                                // 'name.company': this.company,
                                // 'MailAddress.country': this.country,
                                // 'MailAddress.line1': this.address,
                                // 'MailAddress.line2': this.street_address_2,
                                // 'MailAddress.city': this.city,
                                // 'MailAddress.state': this.state,
                                // 'MailAddress.postalCode': this.zip,
                                ...this.$store.state.catalog.catalogForm,
                                hubspotutk,
                            }),
                            axiosConfig
                        )
                        .then((res) => {
                            // console.log('full response', res)
                            this.sending = false
                            this.waiting = true
                            this.$axios
                                .post(
                                    'submitted-web-form',
                                    res.config.data,
                                    axiosConfig
                                )
                                .then((response) => {
                                    gtmEvent({
                                        gtm: this.$gtm,
                                        event: 'catalogForm',
                                        eventType: 'form',
                                        atts: {
                                            ...this.$store.state.catalog
                                                .catalogForm,
                                        },
                                    })
                                    this.resetForm('catalogForm')
                                    this.$recaptcha.reset()
                                    // this.$recaptcha.reset()
                                    // console.log('This was a success on the frontend')
                                    this.loader = false
                                    this.waiting = false
                                    this.success = true
                                    this.okToDownload = true
                                    downloadFile(this.downloadURL, '')
                                })
                                .catch((error) => {
                                    console.log('lambda failure was', error)
                                    this.handleErrors()
                                })
                        })
                        .catch((err) => {
                            console.log(
                                'This order submission failed at Netify for some reason. Please try again. ERROR:',
                                err
                            )
                            this.handleErrors()
                        })
                })
                .catch((err) => {
                    const errorMessage = 'recaptchaFailedMessage'
                    console.log(errorMessage, err)
                    this.handleErrors(errorMessage)
                })
        },
        handleErrors(errorMessage) {
            this.$recaptcha.reset()
            this.loader = false
            this.sending = false
            this.waiting = false
            this.failure = true
            this.hitSnackbar({ string: errorMessage }, {})
        },
        clearFields() {
            this.$store.commit('catalog/clearFields')
        },
    },
}
</script>
